<template>
  <div style="min-width: 1800px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">ETP业务系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>手续费统计</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="10">
        <el-select
          v-model="type"
          placeholder="请选择时间类型"
          @change="getFeeTrend"
          style="float: right; margin-right: 90px; z-index: 9999999"
        >
          <el-option label="日" value="DAY"></el-option>
          <el-option label="月" value="MONTH"></el-option>
        </el-select>
        <div id="service-free" style="width: 100%; height: 350px"></div>
      </el-col>
      <el-col :span="10">
        <div id="coin-service-free" style="width: 100%; height: 350px"></div>
      </el-col>
    </el-row>

    <div>
      <h1 style="font-size: 18px; display: inline-block">手续费列表</h1>
      <span style="font-size: 14px; padding-left: 20px; padding-right: 10px"
        >时间范围</span
      >
      <el-date-picker
        v-model="date"
        type="datetimerange"
        value-format="timestamp"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-button type="primary" @click="searchData">查 询</el-button>

      <el-table
        border
        :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
        style="margin-top: 10px"
        :data="dataList"
        :row-key="() => Math.random()"
      >
        <el-table-column label="序号">
          <el-table-column
            label="合计"
            type="index"
            :index="indexMethod"
            width="100px"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="交易币种">
          <el-table-column label="全部" prop="coin"></el-table-column>
        </el-table-column>
        <el-table-column label="实际手续费（USDT）">
          <el-table-column
            :label="sumFeeStatistics.actualFee + ''"
            prop="actualFee"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="应收手续费（USDT）">
          <el-table-column
            :label="sumFeeStatistics.shouldFee + ''"
            prop="shouldFee"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="返佣部分（USDT）">
          <el-table-column
            :label="sumFeeStatistics.rebate + ''"
            prop="rebate"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="抵扣部分（USDT）">
          <el-table-column
            :label="sumFeeStatistics.deduction + ''"
            prop="deduction"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100px">
          <template slot-scope="scope">
            <el-button type="primary" @click="checkDetail(scope.row.coin)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 30px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParam.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="40%"
      @close="clearData"
    >
      <el-table
        border
        :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
        :data="detailList"
        :row-key="() => Math.random()"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          width="100px"
          label="序号"
        ></el-table-column>
        <el-table-column prop="coinType" label="交易币种"></el-table-column>
        <el-table-column
          prop="actualFee"
          label="实际手续费（USDT）"
        ></el-table-column>
        <el-table-column
          prop="shouldFee"
          label="应收手续费（USDT）"
        ></el-table-column>
        <el-table-column
          prop="rebate"
          label="返佣部分（USDT）"
        ></el-table-column>
        <el-table-column
          prop="deduction"
          label="抵扣部分（USDT）"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import moment from "moment";

export default {
  name: "ServiceFee",
  data() {
    return {
      type: "DAY",
      date: [],
      dataList: [],
      total: 0,
      sumFeeStatistics: {},
      detailList: [],
      dialogVisible: false,
      serviceFreeOption: null,
      serviceFreeChart: null,
      coinServiceFreeOption: null,
      coinServiceFreeChart: null,
      queryParam: { endTime: "", startTime: "", page: 1, size: 10 },
      FORMAT_DAY: "YYYY-MM-DD",
      FORMAT_MONTH: "YYYY-MM",
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    moment(value) {
      if (!value) return "";
      return moment(value).format(
        this.type == "DAY" ? this.FORMAT_DAY : this.FORMAT_MONTH
      );
    },
    searchData() {
      if (this.date) {
        this.queryParam.startTime = this.date[0];
        this.queryParam.endTime = this.date[1];
      } else {
        this.queryParam = { endTime: "", startTime: "" };
      }
      this.getFeeStatisticsList();
    },
    getFeeStatisticsList() {
      api.getFeeStatisticsList(this.queryParam).then(({ data }) => {
        this.dataList = data.feeStatisticsListVOList.records;
        this.total = data.feeStatisticsListVOList.total;
        this.sumFeeStatistics = data.sumFeeStatisticsListVO;
      });
    },
    getFeeTrend() {
      api.getFeeTrend({ dateType: this.type }).then(({ data }) => {
        this.initServiceFree(data);
      });
    },
    getFeeProportion() {
      api.getFeeProportion().then(({ data }) => {
        this.initCoinServiceFree(data);
      });
    },
    initServiceFree(data) {
      let _othis = this;
      let serviceFree = document.getElementById("service-free");
      this.serviceFreeChart = this.$echarts.init(serviceFree);
      this.serviceFreeOption = {
        title: {
          text: "手续费走势",
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          formatter: function (params) {
            return (
              "时间：" +
              _othis.moment(params[0].axisValue) +
              "<br>" +
              "手续费：" +
              params[0].value +
              " USDT"
            );
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [],
            type: "line",
          },
        ],
      };

      if (data) {
        for (let i = 0; i < data.length; i++) {
          this.serviceFreeOption.xAxis.data.push(this.moment(data[i].time));
          this.serviceFreeOption.series[0].data.push(data[i].amount);
        }
      }

      this.serviceFreeOption &&
        this.serviceFreeChart.setOption(this.serviceFreeOption);
    },
    arrCount(arr) {
      let count = 0;
      arr.forEach((item) => {
        console.log(item);
        count = count + item.rate;
      });
      return count;
    },
    initCoinServiceFree(data) {
      let coinServiceFree = document.getElementById("coin-service-free");
      this.coinServiceFreeChart = this.$echarts.init(coinServiceFree);
      this.coinServiceFreeOption = {
        title: {
          text: "各币种手续费",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + " " + params.percent + "%";
          },
        },
        legend: {
          orient: "vertical",
          align: "left",
          left: "right",
          padding: 5,
          itemWidth: 25, 
          itemHeight: 14,
          formatter: (name) => {
            const count = this.arrCount(data);
            const val = data.filter((item) => {
              return item.coin === name;
            });
            return (
              name + "     " + ((val[0].rate / count) * 100).toFixed(2) + "%" + '  '+ (val[0].rate).toFixed(2)+'USDT'
            );
          },
        },
        series: [
          {
            type: "pie",
            radius: "80%",
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 2,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      if (data) {
        for (let i = 0; i < data.length; i++) {
          this.coinServiceFreeOption.series[0].data.push({
            name: data[i].coin,
            value: data[i].rate,
          });
        }
      }

      this.coinServiceFreeOption &&
        this.coinServiceFreeChart.setOption(this.coinServiceFreeOption);
    },
    checkDetail(coin) {
      api
        .getFeeDetail({
          coinBelong: coin,
          startTime: this.queryParam.startTime,
          endTime: this.queryParam.endTime,
        })
        .then(({ data }) => {
          this.detailList = data;
          this.dialogVisible = true;
        });
    },
    handleSizeChange(val) {
      this.queryParam.size = val;
      this.getFeeStatisticsList();
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getFeeStatisticsList();
    },
    clearData() {
      this.detailList = [];
    },
  },
  created() {},
  mounted() {
    this.getFeeStatisticsList();
    this.getFeeTrend();
    this.getFeeProportion();
  },
};
</script>

<style lang="less" scoped></style>

